import { Backend } from '@shared/datastore/core';
import { ContactsGetResultApi } from 'api-typings/contacts/contacts';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    contacts: ContactsGetResultApi;
  }
}

export const contactsBackend: Backend<'contacts'> = {
  fetch: () => ({
    endpoint: `contacts/0.1/contacts`,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contacts/contacts.backend.ts